module.exports = __webpack_public_path__ + "static/Blissfully-1957e4578d86159fffd00dbf36088b73.jpg";